export default function MiniFridge(props: any) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_18_3337)">
                <path
                    d="M25.5 5H6.5C5.67157 5 5 5.67157 5 6.5V24.5C5 25.3284 5.67157 26 6.5 26H25.5C26.3284 26 27 25.3284 27 24.5V6.5C27 5.67157 26.3284 5 25.5 5Z"
                    stroke="#757575"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path d="M12 8H5V12H10.5C11.3284 12 12 11.3284 12 10.5V8Z" stroke="#757575" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 26H8V27H12V26Z" stroke="#757575" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M24 26H20V27H24V26Z" stroke="#757575" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5 8H27" stroke="#757575" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_18_3337">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
